const ZERODHA_DEVELOPERS_URL = 'https://kite.trade/developers/apps';

export const ZERODHA_API_KEY_REJECTED_CODE = 'zerodha_api_key_rejected';

export function parseBrokerErrorDetail(detail) {
  if (!detail) return null;
  if (typeof detail === 'object' && !Array.isArray(detail)) {
    return detail;
  }
  if (typeof detail === 'string') {
    try {
      const parsed = JSON.parse(detail);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch {
      // plain string detail
    }
    if (detail.toLowerCase().includes('invalid api_key')) {
      return { code: ZERODHA_API_KEY_REJECTED_CODE, message: detail };
    }
  }
  return null;
}

export function getBrokerErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const detail = err?.response?.data?.detail;
  const structured = parseBrokerErrorDetail(detail);
  if (structured?.user_message) return structured.user_message;
  if (structured?.message) return structured.message;
  if (typeof detail === 'string') return detail;
  return err?.message || fallback;
}

export function isZerodhaApiKeyRejectedError(err) {
  const structured = parseBrokerErrorDetail(err?.response?.data?.detail);
  return structured?.code === ZERODHA_API_KEY_REJECTED_CODE;
}

export function getDevelopersUrl(err) {
  const structured = parseBrokerErrorDetail(err?.response?.data?.detail);
  return structured?.developers_url || ZERODHA_DEVELOPERS_URL;
}
